<template>
    <div class="fun_box">
    	<div class="warnBox contentBox">
    		<img src="./img/lingdang.png">
    		<div class="overflow">
    			<h3>{{langtrans().gyjypt[languageIndex]}}</h3>
    			<p>{{langtrans().pttzzs[languageIndex]}}+86 10 68180898{{langtrans().yx[languageIndex]}}ops@jiangtai.com</p>
    		</div>
    		<p class="text">2018.09.09</p>
    	</div>
    	<div class="line"></div>
    	<div class="contentBox" style="padding-top: 20px;">
	        <h2>{{langtrans().gnczx[languageIndex]}}</h2>
	        <div class="fun_list">
	            <div class="fun_one fun" @click="tofinish">
	                <img src="../../../static/images/com_images/icon_07.png" alt="">
	                <span>{{langtrans().ywcajc[languageIndex]}}</span>
	            </div>
	        </div>    		
    	</div>

    </div>
</template>

<script>
import langtrans from "./js/footer.vue.trans.js";	
export default {
	computed:{
		languageIndex(){
			return this.$store.state.language
		}
	},	
	  methods: {
		langtrans(){
			return langtrans
		},  	
	    tofinish(){
	        this.$router.push({
	          name: "Finish1",
	          params: {
	          	token: this.$route.params.token||JSON.parse(window.localStorage.getItem("data")).data
	          }
	        });
	      }
	  }
};

</script>

<style scoped>
	.fun_box{background-color: white;padding: 0 0 50px 0;}
	.contentBox{width: 1200px;margin: 0 auto;}
	h2{font-size: 20px;color: #333;}
	.fun_one{margin-top: 20px;cursor: pointer;}
	.fun_one img{vertical-align: middle;}
	.fun_one span{vertical-align: middle;font-size: 18px;padding-left: 10px;color: #666;}
	.warnBox{overflow: hidden;padding: 50px 0;}
	.warnBox img{float: left;}
	.warnBox .overflow{float: left;margin-left: 20px;width: 900px;}
	.warnBox .overflow h3{font-size: 18px;font-weight: normal;}
	.warnBox .overflow p{font-size: 14px;line-height: 30px;color: #666;}
	.warnBox .text{float: right;color: #666;}
	.line{height: 1px;background: #eee;}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/footer.vue